import React from 'react';
interface RequireAuthProps {
  /** Nom du module, conservé pour le retour du flux de connexion. */
  label: string;
  children: React.ReactNode;
}

/**
 * Temporaire : la connexion est désactivée et tous les modules sont ouverts.
 * Le dialogue de connexion (components/auth/AuthDialog) reste disponible.
 */
export function RequireAuth({
  children
}: RequireAuthProps) {
  return <>{children}</>;
}